/* -------------------------------------------------------------------------- */
/*                                Accordion group styles                */
/* -------------------------------------------------------------------------- */

@import './bq-accordion-group.variables';

:host {
  @apply block;
}
